import request from '@/utils/request';

export const getScenePage = (params: any): Promise<IResponse> => {
  return request({
    url: '/portal/scene/page',
    method: 'get',
    params,
  });
};

/**
 * 查询场景详情-后管
 * POST /dataspace-api/portal/scene/detail
 */
export const getSceneMngDetail = (params: any): Promise<IResponse> => {
  return request({
    url: '/portal/scene/detail',
    method: 'post',
    params,
  });
};

/**
 * 获取行业场景分类
 * GET /dataspace-api/portal/scene/industrySceneCategories
 */
export const getIndustrySceneCategories = (): Promise<IResponse> => {
  return request({
    url: '/portal/scene/industrySceneCategories',
    method: 'get',
  });
};

/**
 * 场景关系血缘图
 * GET /dataspace-api/portal/scene/getSceneLineageData
 */
export const getSceneLineageData = (params: any): Promise<IResponse> => {
  return request({
    url: '/portal/scene/getSceneLineageData',
    method: 'get',
    params,
  });
};

/**
 * 根据场景id获取钉钉群聊信息
 * POST /dataspace-api/dingtalk/external/scene/group
 */
export const getSceneGroup = (data: any): Promise<IResponse> => {
  return request({
    url: '/dingtalk/external/scene/group',
    method: 'post',
    data,
  });
};

/**
 * 客服列表
 * GET /dataspace-api/dsAuthUser/customerService/list
 */
export const getCustomerServiceList = (): Promise<IResponse> => {
  return request({
    url: '/dsAuthUser/customerService/list',
    method: 'get',
  });
};

/**
 * 场景-相关资源分页
 * POST /dataspace-api/portal/scene/getSceneProductPage
 */
export const getSceneProductPage = (
  data: any,
  params: any,
): Promise<IResponse> => {
  return request({
    url: '/portal/scene/getSceneProductPage',
    method: 'post',
    data,
    params,
    headers: {
      repeatSubmit: false,
    },
  });
};
